import React, {useEffect, useState} from 'react';
import styled from 'styled-components'
import {truncateString} from "../helper/truncate";


export default function CourseVideoListModule({name, lessonSelected = null, blocks, courseId, courseSlug, visited, favourite, shouldDeploy = false}) {
    const [isDeployed, setIsDeployed] = useState(shouldDeploy)
    const [selected, setSelected] = useState(lessonSelected ? lessonSelected.slug : null)
    const [favouriteMap, setFavouriteMap] = useState(favourite)
    const [visitedMap, setVisitedMap] = useState(visited)

    const [isAlreadySeenFilter, setIsAlreadySeenFilter] = useState(false)
    const [isFavouriteFilter, setIsFavouriteFilter] = useState(false)
    const [queryFilter, setQueryFilter] = useState(null)

    useEffect(() => {
        const listenerseen = () => {
            setIsAlreadySeenFilter(d => !d)
        }

        const listenerfav = () => {
            setIsFavouriteFilter(d => !d)
        }


        const listenerquery = (event) => {
            setQueryFilter(event.detail && event.detail.length > 0 ? event.detail.toLowerCase() : null)
        }

        document.addEventListener('course_filter_favourites', listenerfav)
        document.addEventListener('course_filter_already_seen', listenerseen)
        document.addEventListener('course_filter_query', listenerquery)

        return () => {
            document.removeEventListener('course_filter_favourites', listenerfav)
            document.removeEventListener('course_filter_already_seen', listenerseen)
            document.removeEventListener('course_filter_query', listenerquery)
        }
    }, [])

    useEffect(() => {
        const listener = (event) => {

            let isOnBlock = false
            for (let b of blocks) {
                for (let l of b.leasons) {
                    if (l.slug === event.detail.slug) {
                        isOnBlock = true
                    }
                }
            }

            if (!isOnBlock) {
                setIsDeployed(false)
                setSelected(null)
            } else {
                setSelected(event.detail.slug)
                setIsDeployed(true)
            }
        }

        document.addEventListener('course_select_video', listener)

        const listenerModule = (event) => {
            if (event.detail === name) return;

            setIsDeployed(false)
        }

        document.addEventListener('course_select_block', listenerModule)

        return () => {
            document.removeEventListener('course_select_video', listener)
            document.removeEventListener('course_select_block', listenerModule)
        }
    }, [name, blocks])


    const selectLeason = (leason) => {

        const event = new CustomEvent('course_select_video', {detail: leason});
        document.dispatchEvent(event)

        // push history

        window.history.pushState({},'Gauss Online', `/course/${courseSlug}/lesson/${leason.slug}`);
    }


    const selectModule = () => {
        setIsDeployed(!isDeployed)

        const event = new CustomEvent('course_select_block', {detail: name});
        document.dispatchEvent(event)
    }

    const switchVisited = (leason) => {
        const url = `/ajax/mark-as-visited/${leason.id}/${courseId}`

        setVisitedMap(vis => {
            return {
                ...vis,
                [leason.id]: !!!vis[leason.id]
            }
        })

        fetch(url)
            .then(res => res.json())
            .then(resp => {

            })

    }


    const switchFavorite = (leason) => {
        const url = `/ajax/mark-as-favorite/${leason.id}/${courseId}`

        setFavouriteMap(vis => {
            return {
                ...vis,
                [leason.id]: !!!vis[leason.id]
            }
        })

        fetch(url)
            .then(res => res.json())
            .then(resp => {


            })

    }

    if (isAlreadySeenFilter || isFavouriteFilter || (queryFilter && queryFilter.length > 0)) {
        return (
            <Container isDeployed={true}>
                {blocks.map(block => {
                    return block.leasons
                        .filter(l => (isAlreadySeenFilter && visitedMap[l.id]) || (isFavouriteFilter && favouriteMap[l.id]) || (l.name.toLowerCase().indexOf(queryFilter) > -1))
                        .map(leason => {
                            return (
                                <LeasonRow
                                    isSelected={selected === leason.slug}
                                    key={`leason_row_${leason.id}`}>
                                    <IconFilter
                                        onClick={() => switchFavorite(leason)}
                                        src={`https://d2wl56ig1uoitb.cloudfront.net/images/${favouriteMap[leason.id] ? 'star_fill.svg' : 'star.svg'}`}/>

                                    <IconFilter
                                        onClick={() => switchVisited(leason)}
                                        src={`https://d2wl56ig1uoitb.cloudfront.net/images/${visitedMap[leason.id] ? 'eye_fill.svg' : 'eye.svg'}`}/>

                                    <div onClick={() => selectLeason(leason)}>{leason.name} </div>
                                </LeasonRow>
                            )
                        })
                })}
            </Container>
        )


    }

    return (
        <Container isDeployed={isDeployed}>
            <BlockContainer onClick={selectModule}>
                <Name isDeployed={isDeployed}>{isDeployed ? name : truncateString(name, 35)}</Name>
                <IconCollapse isDeployed={isDeployed} src='/images/arrow.svg'/>
            </BlockContainer>

            {isDeployed && (
                blocks.map((block, id) => {
                    return (
                        <Block key={`block_video_${id}`}>
                            <BlockName>{block.name}</BlockName>


                            {block.leasons.map(leason => {
                                return (
                                    <LeasonRow

                                        isSelected={selected === leason.slug}
                                        key={`leason_row_${leason.id}`}>
                                        <IconFilter
                                            onClick={() => switchFavorite(leason)}
                                            src={`https://d2wl56ig1uoitb.cloudfront.net/images/${favouriteMap[leason.id] ? 'star_fill.svg' : 'star.svg'}`}/>

                                        <IconFilter
                                            onClick={() => switchVisited(leason)}
                                            src={`https://d2wl56ig1uoitb.cloudfront.net/images/${visitedMap[leason.id] ? 'eye_fill.svg' : 'eye.svg'}`}/>
                                        <LeasonTitleFree style={{flex: 1}} onClick={() => selectLeason(leason)}>

                                            {leason.isFree ? (<Free>FREE</Free>) : null}
                                            <div>{leason.name}</div>
                                        </LeasonTitleFree>
                                    </LeasonRow>
                                )
                            })}
                        </Block>
                    )
                })
            )}
        </Container>
    )

}


const IconCollapse = styled.img`
    width: 20px;
    transform: rotate(${props => props.isDeployed ? '90' : '0'}deg);
`
const BlockContainer = styled.div`
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    cursor: pointer;
    height: 35px;
`

const Container = styled.div`

    border: 1px solid #1A2024;
    padding: 8px;
    border-radius: 4px;
    background-color: #1A2024;
    margin-top: 12px;
    &: hover {
        border: 1px solid #FA9F63;
    }
    overflow: hidden;
    max-height: ${props => props.isDeployed ? '400vh' : '80px'};
    transition: max-height 1s ease;
`


const Name = styled.div`
    cursor: pointer;
    color: ${props => props.isDeployed ? '#E8A273' : '#A5ABAF'};
    font-size: 18px;
    padding-bottom: 8px;
    padding-top: 8px;
    text-align: left;

    &:hover {
       color: #E8A273;
    }
`

const Block = styled.div`
    cursor: pointer;
`
const BlockName = styled.div`
     color: #A5ABAF;
     font-size: 16px;
     padding-bottom: 8px;
    padding-top: 8px;
    text-align: center;
`

const LeasonTitleFree = styled.div`
 display: flex;
    flex-direction: row;
`
const LeasonRow = styled.div`
    padding-top: 4px;
    padding-bottom: 4px;
    cursor: pointer;
    background-color: ${props => props.isSelected ? '#817E9F' : 'transparent'};
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    color: white;

    &:hover {
        color: #5F676D;
    }

`

const IconFilter = styled.img`
    width: 18px;
    height: 18px;
    margin-right: 4px;
`
const Free = styled.div`
 color: #B5EF8A;
 margin-left: 4px;
 margin-right: 4px;
`
